export function getBaseUrl() {
    
    if (window.location.host.startsWith("localhost")) {
      return "https://api-dev.onlinecv.app";
    } else if (window.location.host.startsWith("dev.") || window.location.host.startsWith("www.dev.")) {
      return "https://api-dev.onlinecv.app";
    } else if (window.location.host.startsWith("onlinecv.") || window.location.host.startsWith("www.onlinecv.")) {
      return "https://api.onlinecv.app";
    }
}